import React from 'react'
import { Button } from '@/components/ui'
import { messages } from './messages'
import type { IFinancingUxFeedbackModalFormActionsProps } from './types'
import './styles.scss'

export const FinancingUxFeedbackModalFormActions = (props: IFinancingUxFeedbackModalFormActionsProps) => {
  const { isNotDisabledAction, isHasSkipButton, onSkipAction } = props

  return (
    <div className="financingUxFeedbackModalFormActions">
      {isHasSkipButton && (
        <Button className="financingUxFeedbackModalFormActions__link" modifiers={['as-link']} onClick={onSkipAction}>
          {messages.skip}
        </Button>
      )}
      <Button type="submit" modifiers={['green', 'full-width-mobile']} isDisabled={!isNotDisabledAction}>
        {messages.action}
      </Button>
    </div>
  )
}
